// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2017 TypeFox and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

:root {
  --theia-statusBar-height: 22px;
}

#theia-statusBar {
  background: var(--theia-statusBar-background);
  display: flex;
  min-height: var(--theia-statusBar-height);
  white-space: nowrap;
  border-top: var(--theia-border-width) solid var(--theia-statusBar-border);
}

body.theia-no-open-workspace #theia-statusBar {
  background: var(--theia-statusBar-noFolderBackground);
  color: var(--theia-statusBar-noFolderForeground);
  border-top: var(--theia-border-width) solid
  var(--theia-statusBar-noFolderBorder);
}

#theia-statusBar .area {
  flex: 1;
  display: flex;
  align-items: stretch;
}

#theia-statusBar .area.left {
  justify-content: flex-start;
}

#theia-statusBar .area.right {
  justify-content: flex-end;
  padding-right: calc(var(--theia-ui-padding) * 2);
}

#theia-statusBar .area .element {
  color: var(--theia-statusBar-foreground);
  display: flex;
  align-items: center;
  font-size: var(--theia-statusBar-font-size);
}

#theia-statusBar .area.left .element.has-background {
  margin-left: 0px;
  margin-right: 3px;
  padding-left: 7px;
  padding-right: 7px;
}
#theia-statusBar .area .element>* {
  margin-left: calc(var(--theia-ui-padding)/2);
}

#theia-statusBar .area .element .codicon {
  /* Scaling down codicons from 16 to 14 pixels */
  font-size: 14px;
}

#theia-statusBar .area .element > *:last-child {
  margin-right: calc(var(--theia-ui-padding) / 2);
}

.theia-mod-offline #theia-statusBar {
  background-color: var(--theia-statusBar-offlineBackground) !important;
}

.theia-mod-offline #theia-statusBar .area .element {
  color: var(--theia-statusBar-offlineForeground) !important;
}

#theia-statusBar .area.left .element:first-child:not(.has-background) {
    margin-left: calc(var(--theia-ui-padding) * 3);
}
#theia-statusBar .area.left .element {
  margin-right: var(--theia-ui-padding);
}

#theia-statusBar .area.right .element {
  margin-left: var(--theia-ui-padding);
}

#theia-statusBar .area.right .element.compact-right,
#theia-statusBar .area.right .element.compact-left + .element {
  margin-left: 0;
}

#theia-statusBar .area.left .element.compact-left {
  margin-right: 0;
}

#theia-statusBar .area.left .element.compact-right {
  margin-left: calc(-1 * var(--theia-ui-padding));
}

#theia-statusBar .area .element.hasCommand:hover {
  cursor: pointer;
}

#theia-statusBar .area .element.hasCommand:active {
  cursor: pointer;
}

#theia-statusBar .element {
  /* https://css-tricks.com/os-specific-fonts-css/#article-header-id-0 */
  /* https://github.com/Microsoft/vscode/blob/5dbdc8d19c8cf6dd10d558eabcc48bba962ea45f/src/vs/workbench/browser/media/style.css#L8-L24 */
  font-family: -apple-system, BlinkMacSystemFont, "Segoe WPC", "Segoe UI",
    "Ubuntu", "Droid Sans", sans-serif;
  font-size: 12px;
  text-rendering: auto;
  text-decoration: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/core/src/browser/style/status-bar.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;EACE,8BAA8B;AAChC;;AAEA;EACE,6CAA6C;EAC7C,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,yEAAyE;AAC3E;;AAEA;EACE,qDAAqD;EACrD,gDAAgD;EAChD;uCACqC;AACvC;;AAEA;EACE,OAAO;EACP,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,4CAA4C;AAC9C;;AAEA;EACE,+CAA+C;EAC/C,eAAe;AACjB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,qEAAqE;AACvE;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;IACI,8CAA8C;AAClD;AACA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sEAAsE;EACtE,sIAAsI;EACtI;sCACoC;EACpC,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,mCAAmC;EACnC,kCAAkC;AACpC","sourcesContent":["/********************************************************************************\n * Copyright (C) 2017 TypeFox and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n:root {\n  --theia-statusBar-height: 22px;\n}\n\n#theia-statusBar {\n  background: var(--theia-statusBar-background);\n  display: flex;\n  min-height: var(--theia-statusBar-height);\n  white-space: nowrap;\n  border-top: var(--theia-border-width) solid var(--theia-statusBar-border);\n}\n\nbody.theia-no-open-workspace #theia-statusBar {\n  background: var(--theia-statusBar-noFolderBackground);\n  color: var(--theia-statusBar-noFolderForeground);\n  border-top: var(--theia-border-width) solid\n  var(--theia-statusBar-noFolderBorder);\n}\n\n#theia-statusBar .area {\n  flex: 1;\n  display: flex;\n  align-items: stretch;\n}\n\n#theia-statusBar .area.left {\n  justify-content: flex-start;\n}\n\n#theia-statusBar .area.right {\n  justify-content: flex-end;\n  padding-right: calc(var(--theia-ui-padding) * 2);\n}\n\n#theia-statusBar .area .element {\n  color: var(--theia-statusBar-foreground);\n  display: flex;\n  align-items: center;\n  font-size: var(--theia-statusBar-font-size);\n}\n\n#theia-statusBar .area.left .element.has-background {\n  margin-left: 0px;\n  margin-right: 3px;\n  padding-left: 7px;\n  padding-right: 7px;\n}\n#theia-statusBar .area .element>* {\n  margin-left: calc(var(--theia-ui-padding)/2);\n}\n\n#theia-statusBar .area .element .codicon {\n  /* Scaling down codicons from 16 to 14 pixels */\n  font-size: 14px;\n}\n\n#theia-statusBar .area .element > *:last-child {\n  margin-right: calc(var(--theia-ui-padding) / 2);\n}\n\n.theia-mod-offline #theia-statusBar {\n  background-color: var(--theia-statusBar-offlineBackground) !important;\n}\n\n.theia-mod-offline #theia-statusBar .area .element {\n  color: var(--theia-statusBar-offlineForeground) !important;\n}\n\n#theia-statusBar .area.left .element:first-child:not(.has-background) {\n    margin-left: calc(var(--theia-ui-padding) * 3);\n}\n#theia-statusBar .area.left .element {\n  margin-right: var(--theia-ui-padding);\n}\n\n#theia-statusBar .area.right .element {\n  margin-left: var(--theia-ui-padding);\n}\n\n#theia-statusBar .area.right .element.compact-right,\n#theia-statusBar .area.right .element.compact-left + .element {\n  margin-left: 0;\n}\n\n#theia-statusBar .area.left .element.compact-left {\n  margin-right: 0;\n}\n\n#theia-statusBar .area.left .element.compact-right {\n  margin-left: calc(-1 * var(--theia-ui-padding));\n}\n\n#theia-statusBar .area .element.hasCommand:hover {\n  cursor: pointer;\n}\n\n#theia-statusBar .area .element.hasCommand:active {\n  cursor: pointer;\n}\n\n#theia-statusBar .element {\n  /* https://css-tricks.com/os-specific-fonts-css/#article-header-id-0 */\n  /* https://github.com/Microsoft/vscode/blob/5dbdc8d19c8cf6dd10d558eabcc48bba962ea45f/src/vs/workbench/browser/media/style.css#L8-L24 */\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe WPC\", \"Segoe UI\",\n    \"Ubuntu\", \"Droid Sans\", sans-serif;\n  font-size: 12px;\n  text-rendering: auto;\n  text-decoration: none;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
